import { ReleaseOperation } from "./releaseWriter";

export interface PendingRelease {
    fingerprint: string;
    operation: ReleaseOperation;
}

const MAX_RECORD_LENGTH = 4_000_000;

export const readPendingRelease = (storage: Storage, key: string, scope: string): PendingRelease | undefined => {
    const raw = storage.getItem(key);
    if (!raw) return undefined;
    if (raw.length > MAX_RECORD_LENGTH) throw new Error("배포 복구 기록이 너무 큽니다.");
    const record = JSON.parse(raw) as PendingRelease;
    const operation = record?.operation;
    if (!operation || typeof record.fingerprint !== "string" || !Array.isArray(operation.writes) ||
        !operation.writes.length || !Number.isInteger(operation.completed) || operation.completed < 0 || operation.completed > operation.writes.length ||
        operation.writes.some(write => typeof write.id !== "string" || !write.id || write.id.includes("/") ||
            typeof write.table !== "string" || write.table.split("/").length !== 3 || !write.table.startsWith(`${scope}/`) ||
            !write.table.endsWith("/Report") || !write.data || typeof write.data !== "object")) {
        throw new Error("배포 복구 기록을 확인하지 못했습니다.");
    }
    return record;
};

export const savePendingRelease = (storage: Storage, key: string, pending: PendingRelease): void => {
    const raw = JSON.stringify(pending);
    if (raw.length > MAX_RECORD_LENGTH) throw new Error("배포할 과제가 너무 많습니다. 배포 대상을 나누어 시도해주세요.");
    storage.setItem(key, raw);
};
